// eslint-disable-next-line no-unused-vars
import React from 'react';
import { node } from 'prop-types';
import styled from '@emotion/styled';
import { Loading } from '@carbon/react';
import { useContextSelector } from 'use-context-selector';
import { Helmet } from 'react-helmet';

import { StyledOverlay } from 'Components/Products/Products';
import { ProductContext } from 'Contexts/ProductContext';
import ProductUnavailable from 'Components/Product/ProductUnavailable';

const StyledProductPage = styled.div`
  position: relative;

  .overlay {
    justify-content: center;
  }

  .pageLoading {
    position: sticky;
    top: 50%;
    left: 50%;
    z-index: 99;
    width: 2rem;
    height: 2rem;
  }
`;

const ViewProductPage = ({ children }) => {
  const { product, isLoading } = useContextSelector(ProductContext, data => ({
    product: data.data,
    isLoading: data.isLoading
  }));
  return (
    <StyledProductPage className={ `${ isLoading ? 'loading' : '' }` }>
      <Helmet>
        <title>{ product?.title?.substr(0, 75) }</title>
      </Helmet>
      <StyledOverlay className="overlay" open={ isLoading && product?.id }>
        { (isLoading && product?.id) && (
          <Loading className="pageLoading" active small withOverlay={ false } />
        ) }
      </StyledOverlay>
      <div className="productsContainer">
        { (
          isLoading
          || (!isLoading && product?.id)
        )
          ? children
          : <ProductUnavailable />
        }
      </div>
    </StyledProductPage>
  );
};

ViewProductPage.propTypes = {
  children: node
};
ViewProductPage.displayName = 'ViewProductPageComponent';

export default ViewProductPage;
